import * as React from 'react';

import * as PropTypes from 'prop-types';

import {ButtonIcon} from 'pac-ux-components';

import {I18n} from '@aws-amplify/core';

import {Box, Grid, SimpleGrid, Stack} from '@mantine/core';

import {ApplicationsList} from './ApplicationsList';

import {IconContext} from 'react-icons';
import {MdSwapVert} from 'react-icons/md';

import styled from 'styled-components';


const StyledSwapPositionsButtonBox = styled(Box)`
  height: 100%;
  display: flex;
  align-items: center;
`;

const SwapPositionsButton = ({onClick}) => {
    const iconContext = {
        style: {
            width: `24px`,
            height: `24px`,
        },
    };

    return (
        <ButtonIcon
            title="Swap Positions"
            // icon={<Image src={SwapIcon} alt="Swap" />}
            icon={
                <IconContext.Provider value={iconContext}>
                    <MdSwapVert/>
                </IconContext.Provider>
            }
            onClick={onClick}
        />
    );
};

const ReturnToSection = ({
                             applications,
                             deleteApplication,
                             swapPositions,
                         }) => {
    if (Array.isArray(applications) && applications.length === 0) {
        return null;
    }

    return (
        <SimpleGrid>
            <Box mt="lg" variant="h2">
                {I18n.get('Return to:')}
            </Box>

            {applications.length > 1 ? (
                <Grid>
                    <Grid.Col xs={2} sm={1}>
                        <Stack
                            align="center"
                            justify="center"
                            style={{height: '100%'}}
                        >
                            <SwapPositionsButton onClick={swapPositions}/>
                        </Stack>
                    </Grid.Col>
                    <Grid.Col xs={10} sm={11}>
                        <ApplicationsList
                            applications={applications}
                            deleteApplication={deleteApplication}
                        />
                    </Grid.Col>
                </Grid>
            ) : (
                <ApplicationsList
                    applications={applications}
                    deleteApplication={deleteApplication}
                />
            )}
        </SimpleGrid>
    );
};

ReturnToSection.propTypes = {
    applications: PropTypes.array,
    deleteApplication: PropTypes.func,
    swapPositions: PropTypes.func,
};

SwapPositionsButton.propTypes = {
    onClick: PropTypes.func,
};

export default ReturnToSection;
